<template>
  <b-modal id="anti-cheat-modal" hide-header centered no-close-on-backdrop no-close-on-esc>
    <h3 class="text-site-primary">Warning</h3>

    <br />You will not be allowed open other programs/browser tabs once you've begun the test. Refreshing the browser window is also prohibited.
    <br />

    <br />Your account will be locked should you breach these guidelines once more
    <br />
    <template v-slot:modal-footer="{ ok }">
      <b-button variant="primary" class="bg-site-primary" @click="ok()">I understand</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      warningsGiven: false,
    };
  },
  mounted() {
    // Tab Switching
    var self = this
    var testStarted = this.$store.getters[`exam/testStarted`]
    if(testStarted === `true`){
      return this.lockUser(`testStarted`)
    }
    else{
      this.$store.commit(`exam/testStarted`, true)
    }
    // Refresh Check
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        self.strike(`visibilitychange`)
      }
    });

    window.addEventListener("blur", function () {
      if (document.hidden) {
        self.strike(`blur`)
      }
    });

    window.onbeforeunload = function() {
      return "WARNING: You are not allowed to close/refresh this page. If you continue, your account will be locked";
    };

    document.addEventListener("keydown", function (event) {
      var keyPressed = event.which || event.keyCode;
      if (keyPressed == 116) event.preventDefault();
      // F5
      else if (keyPressed == 17) event.preventDefault();
      // Ctrl
      else if (keyPressed == 82) event.preventDefault();
      // R
      else if (keyPressed == 87) event.preventDefault();
      // W
      else if (keyPressed == 18) event.preventDefault(); // Alt
    });
  },
  methods: {
    strike(reason) {
      if (!this.warningsGiven) {
        this.warningsGiven = true;
        this.$bvModal.show("anti-cheat-modal");
      } else {
        this.lockUser(reason)
      }
    },
    lockUser(){
      this.$store.commit(`exam/testStarted`, false)
      this.$store
          .dispatch("examinee/update", {
            id: this.$store.getters["user/roleId"],
            data: { status: "locked" },
          })
          .then(() => {
            return this.$router.push(`/examinee/locked`);
          })
          .catch((err) => {
            console.log(err);
          });
    }
  },
};
</script>

<style lang="scss" scoped>
</style>